const validateForm = (
  {
    name,
    heightMin,
    heightMax,
    weightMin,
    weightMax,
    lifeSpanMin,
    lifeSpanMax,
  },
  temps
) => {
  heightMin = Number(heightMin);
  heightMax = Number(heightMax);
  weightMin = Number(weightMin);
  weightMax = Number(weightMax);
  lifeSpanMin = Number(lifeSpanMin);
  lifeSpanMax = Number(lifeSpanMax);
  const errors = {};
  if (!name.length) errors.name = "La raza debe tener un nombre";
  else if (name[0] !== name[0].toUpperCase())
    errors.name = "El nombre de la raza debe comenzar con mayusculas";

  if (heightMin <= 0 || heightMax <= 0) {
    errors.height = "La raza debe tener altura mínima y máxima";
  } else if (heightMin > heightMax) {
    errors.height = "La altura mínima no puede ser mayor a la altura máxima";
  } else if (heightMax > 100)
    errors.height = "La altura máxima no puede ser mayor a 110 cms";

  if (weightMin <= 0 || weightMax <= 0)
    errors.weight = "La raza debe tener peso mínimo y máximo";
  else if (weightMin > weightMax) {
    errors.weight = "El peso mínimo no puede ser mayor a el peso máximo";
  } else if (weightMax > 100)
    errors.weight = "El peso máximo no puede ser mayor a 100 Kgs";

  if (lifeSpanMin <= 0 || lifeSpanMax <= 0)
    errors.lifeSpan = "La raza debe esperanza de vida mínima y máxima";
  else if (lifeSpanMin > lifeSpanMax) {
    errors.lifeSpan =
      "La esperanza de vida mínima no puede ser mayor a la esperanza de vida máxima";
  } else if (lifeSpanMax > 20)
    errors.lifeSpan =
      "La esperanza de vida máxima no puede ser mayor a 20 años";

  if (!temps.length)
    errors.temps = "La raza debe tener almenos tipo de temperamento";

  return errors;
};

export default validateForm;
